import "./platform-review.css";

const PlatformReviewComponent = () => {
  return (
    <section className="">
      <div className="tutor-page-reviews">
        <div className="tutor-page-reviews-item">
          <div className="review-logo-row">
            <img src="/google-icon.svg" alt="profilePic" className="review-logo-small" />
            <span className="tutor-page-reviews-item-heading"> Google</span>
          </div>
          <div className="tutor-page-reviews-stars">
            <img src="/star-icon.svg" alt="star icon" className="review-star-icon" />
            <img src="/star-icon.svg" alt="star icon" className="review-star-icon" />
            <img src="/star-icon.svg" alt="star icon" className="review-star-icon" />
            <img src="/star-icon.svg" alt="star icon" className="review-star-icon" />
            <img src="/star-icon.svg" alt="star icon" className="review-star-icon" />
          </div>
          <div className="platform-review-content">
            Trusted Source <span>4.8</span>{" "}
          </div>
          <div className="platform-review-content">
            <span>1,013+ </span>
            reviews
          </div>
        </div>

        <div className="tutor-page-reviews-item">
          <div className="review-logo-row">
            <img src="/review-just-dial-icon.svg" alt="profilePic" className="review-logo-medium" />
          </div>
          <div className="tutor-page-reviews-stars">
            <img src="/star-icon.svg" alt="star icon" className="review-star-icon" />
            <img src="/star-icon.svg" alt="star icon" className="review-star-icon" />
            <img src="/star-icon.svg" alt="star icon" className="review-star-icon" />
            <img src="/star-icon.svg" alt="star icon" className="review-star-icon" />
            <img src="/star-icon.svg" alt="star icon" className="review-star-icon" />
          </div>
          <div className="platform-review-content">
            Trusted Source <span>4.7</span>{" "}
          </div>
          <div className="platform-review-content">
            <span>827+</span>
            reviews
          </div>
        </div>

        <div className="tutor-page-reviews-item">
          <div className="review-logo-row">
            <img src="/mouth-shut-icon.gif" alt="profilePic" className="review-logo-medium" />
          </div>
          <div className="tutor-page-reviews-stars">
            <img src="/star-icon.svg" alt="star icon" className="review-star-icon" />
            <img src="/star-icon.svg" alt="star icon" className="review-star-icon" />
            <img src="/star-icon.svg" alt="star icon" className="review-star-icon" />
            <img src="/star-icon.svg" alt="star icon" className="review-star-icon" />
            <img src="/star-icon.svg" alt="star icon" className="review-star-icon" />
          </div>
          <div className="platform-review-content">
            Trusted Source <span>4.5</span>{" "}
          </div>
          <div className="platform-review-content">
            <span>1177+ </span>
            reviews
          </div>
        </div>

        <div className="tutor-page-reviews-item">
          <div className="review-logo-row">
            <img src="/glassdoor-icon.svg" alt="profilePic" className="review-logo-small" />
            <span className="tutor-page-reviews-item-heading">Glassdoor</span>
          </div>
          <div className="tutor-page-reviews-stars">
            <img src="/star-icon.svg" alt="star icon" className="review-star-icon" />
            <img src="/star-icon.svg" alt="star icon" className="review-star-icon" />
            <img src="/star-icon.svg" alt="star icon" className="review-star-icon" />
            <img src="/star-icon.svg" alt="star icon" className="review-star-icon" />
            <img src="/star-icon.svg" alt="star icon" className="review-star-icon" />
          </div>
          <div className="platform-review-content">
            Trusted Source <span>4.8</span>{" "}
          </div>
          <div className="platform-review-content">
            <span>50+ </span>
            reviews
          </div>
        </div>
      </div>
    </section>
  );
};

export default PlatformReviewComponent;
